'use client';

import { useState } from 'react';
import { buildSortedFeatures } from '@/utils/features/build-features';
import clsx from 'clsx';

import Button from '@/components/ui/button';

import { FeaturesGroup } from '../feature/features-group';

export const ListingAmenities: React.FC<{
  amenitiesByCategory: Record<string, ReturnType<typeof buildSortedFeatures>>;
}> = ({ amenitiesByCategory }) => {
  const [showMore, setShowMore] = useState(false);
  return (
    <div className="property-amenities flex flex-col gap-[1rem] border-b pt-[1rem]">
      <h4 id="features" className="section-header">
        Features
      </h4>
      <div className={clsx('flex flex-col')}>
        {Object.entries(amenitiesByCategory)
          .sort(([catA], [catB]) => catA.localeCompare(catB))
          .slice(0, showMore ? Object.entries(amenitiesByCategory).length : 1)
          .map(([category, features], index) => {
            return (
              <div
                key={`${category}-${index + 1}`}
                className="relative flex flex-col gap-2 pt-2 first:pt-0"
              >
                <span className="text-[1.125rem] font-semibold leading-[1.575rem] tracking-[0.01125rem]">
                  {category}
                </span>
                <FeaturesGroup features={features} />
              </div>
            );
          })}
      </div>
      <footer className="pb-[1rem]">
        <Button
          onClick={() => {
            setShowMore((prev) => !prev);
          }}
          style="text"
        >
          <div className="flex flex-row items-center text-secondary-main transition-all duration-200 hover:!text-secondary-light">
            {showMore ? 'Hide' : 'View All'}
            <svg
              className={clsx(
                '-mt-[0.25rem] ml-[0.5rem]',
                showMore && 'rotate-180'
              )}
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="12"
              viewBox="0 0 18 12"
              fill="none"
            >
              <path
                d="M2 2.5L9 9.5L16 2.5"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </Button>
      </footer>
    </div>
  );
};
